<template>
  <div class="app-container">
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" label-width="110px" size="mini">
        <div class="formItemBox">
            <el-form-item label="客户名称:" prop="customerName" v-if="customFlag">
              <el-input  placeholder="" v-model="searchFrom.customerName"></el-input>
            </el-form-item>
            <el-form-item label="承运商名称:" prop="customerName" v-if="!customFlag">
              <el-input  placeholder="" v-model="searchFrom.customerName"></el-input>
            </el-form-item>
            <!-- <el-form-item label="统一社会信用代码:" label-width="130px" prop="customerTaxId">
              <el-input  placeholder="" v-model="searchFrom.customerTaxId"></el-input>
            </el-form-item> -->
        </div>
        <div class="searchBtnBox" style="margin-top:10px;margin-bottom:10px;">
          <el-form-item>
            <el-button type="primary" @click="searchFn" size="mini">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetForm('searchFrom')" size="mini">重置</el-button>
          </el-form-item>
          <el-form-item >
            <el-button type="primary" @click="addFn" size="mini" v-if="btnFlg[0]">新增</el-button>
          </el-form-item>
          <el-form-item >
            <el-button type="primary" @click="bindingFn" size="mini" v-if="btnFlg[4]">绑定</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList" ref="tableList"  class="tableComent" v-loading="loading" bordersize="mini" @selection-change='selectGoods'
      @row-click="handleRowClick" style="width: 100%" height="100%" center border>
        <el-table-column type="selection" width="55" v-if="customFlag"></el-table-column>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="delFn(scope.row)" v-if="btnFlg[1]">删除</el-button>
            <el-button type="text" size="mini" @click="lookPhotos(scope.row)">营业执照</el-button>
            <el-button type="text" size="mini" @click="contractClick(scope.row)" v-if="btnFlg[2]">签订</el-button>
            <el-button type="text" size="mini" @click="editFn(scope.row)" v-if="btnFlg[3]">修改</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="customerName" width="260" :formatter="emptyFn" :show-overflow-tooltip="true" label="结算客户" v-if="customFlag"></el-table-column>
        <el-table-column prop="customerName" width="260" :formatter="emptyFn" :show-overflow-tooltip="true" label="承运商名称" v-if="!customFlag"></el-table-column>
        <el-table-column prop="locatedIn" min-width="280" :formatter="emptyFn" label="企业地址" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="periodDays" min-width="100" :formatter="emptyFn" label="账期(天)"></el-table-column>
        <el-table-column prop="" min-width="130" :formatter="emptyFn" label="账期计算开始日">
          <template scope="scope">
            <span v-if="scope.row.periodDaysType == '0'">运单开票时间</span>
            <span v-else-if="scope.row.periodDaysType == '1'">运单创建时间</span>
            <span v-else-if="scope.row.periodDaysType == '2'">运单签收时间</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="invoiceDays" min-width="120" :formatter="emptyFn" label="到票期限(天)" v-if="!customFlag"></el-table-column>
        <el-table-column prop="" min-width="100" :formatter="emptyFn" label="合同数">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="contractNumberFn(scope.row)">{{scope.row.contractNumber}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="contractOverdueNumber" width="100" label="超期预警">
          <template slot-scope="scope">
            <span v-if="scope.row.contractOverdueNumber==0">{{scope.row.contractOverdueNumber}}</span>
            <span v-else style="color:#d51212;">{{scope.row.contractOverdueNumber}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="customerTaxId" width="200" :formatter="emptyFn" label="统一社会信用代码"></el-table-column>
        <el-table-column prop="onlineFreightFlag" width="100" :formatter="emptyFn" label="网货平台" v-if="!customFlag">
          <template scope="scope">
            <span v-show="scope.row.onlineFreightFlag == '0'">否</span>
            <span v-show="scope.row.onlineFreightFlag == '1'">是</span>
          </template>
        </el-table-column>
        <el-table-column prop="contactsUser" :show-overflow-tooltip="true" width="120" :formatter="emptyFn" label="联系人"></el-table-column>
        <el-table-column prop="contactsMobile" width="120" :formatter="emptyFn" label="联系电话"></el-table-column>
        <el-table-column prop="" width="120" :formatter="emptyFn" label="业务人员" v-if="customFlag">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="busUserFn(scope.row)">{{ scope.row.businessUserName }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="onlineFreightFlag" width="100" :formatter="emptyFn" label="是否共享" v-if="customFlag">
          <template scope="scope">
            <span v-show="scope.row.shareFlag == '0'">不共享</span>
            <span v-show="scope.row.shareFlag == '1'">共享</span>
          </template>
        </el-table-column>
        <el-table-column prop="createUser" :formatter="emptyFn" label="创建人" width="130"></el-table-column>
        <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新建修改 -->
    <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeDialog" :visible.sync="dialogVisible" width="1100px" center v-if="dialogVisible">
      <span>
        <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline" label-width="130px" size="mini">
          <div class="inpBox">
            <div>
              <div style="margin-left: 30px;margin-bottom:20px;font-size: 17px;font-weight: 600;">基础信息</div>
              <el-form-item label="客户类型:" prop="shareFlag" v-if="customFlag">
                <template >
                  <el-radio-group v-model="addFrom.customerType"  @change="KHLXchage" >
                    <el-radio :label="1" >企业</el-radio>
                    <el-radio :label="2">个人</el-radio>
                  </el-radio-group>
                </template>
              </el-form-item>
              <el-form-item label="结算客户:" prop="customerName" v-if="customFlag">
                <el-input placeholder="" maxlength="30" v-model.trim="addFrom.customerName"
                  @blur="nameBlur" ></el-input>
              </el-form-item>
              <el-form-item label="承运商名称:" prop="customerName" v-if="!customFlag">
                <el-input placeholder="" maxlength="30" v-model.trim="addFrom.customerName"
                  @blur="nameBlur" ></el-input>
              </el-form-item>
              <el-form-item label="身份证号:" prop="customerTaxId" v-if="addFrom.customerType==2">
                <el-input  v-model.trim="addFrom.customerTaxId"  ></el-input>
              </el-form-item>
              <el-form-item label="统一社会信用代码:" label-width="150px" v-if="disCustomerTaxId">
                <el-input disabled v-model.trim="addFrom.customerTaxId"
                ></el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="企业地址:" prop="locatedIn" class="dizhi">
                <el-input placeholder="" class="disabled" maxlength="300" :readonly="true" v-model="addFrom.locatedIn"></el-input>
                <i class="el-icon-location" @click="dizhiFn"></i>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="联系人:" prop="contactsUser" >
                <el-input placeholder="" maxlength="20" v-model.trim="addFrom.contactsUser"></el-input>
              </el-form-item>
              <el-form-item label="联系电话:" prop="contactsMobile">
                <el-input placeholder="" maxlength="11" v-model.trim="addFrom.contactsMobile"></el-input>
              </el-form-item>
            </div>
            <el-form-item label="营业执照:" v-if="dialogVisible">
              <uploadImgs :imgList.sync='imgList' style="margin-top:5px;" @remove='remove'></uploadImgs>
            </el-form-item>
            <div style="margin-top: -20px; margin-left: 30px;font-size: 17px;font-weight: 600;">结算设置</div>
            <div style="margin-top: 20px;">
              <el-form-item label="账期(天):" prop="periodDays" >
                <el-input maxlength="5" v-model.trim="addFrom.periodDays" v-number-input.float="0"></el-input>
              </el-form-item>
              <el-form-item label="账期计算开始日:" prop="periodDaysType">
                <el-select v-model="addFrom.periodDaysType" placeholder="请选择">
                  <el-option label="运单开票时间" value="0"></el-option>
                  <el-option label="运单创建时间" value="1"></el-option>
                  <el-option label="运单签收时间" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="到票期限(天):" prop="invoiceDays" v-if="!customFlag">
                <el-input maxlength="5" v-model.trim="addFrom.invoiceDays" v-number-input.float="0"></el-input>
              </el-form-item>
              <el-form-item label="服务费率(%):" prop="serviceRate" v-if="!customFlag">
                <el-input maxlength="5" v-model.trim="addFrom.serviceRate" v-number-input.float="2"></el-input>
              </el-form-item>
              <el-form-item label="运费税率(%):" prop="taxRate" v-if="!customFlag">
                <el-input maxlength="5" v-model.trim="addFrom.taxRate" v-number-input.float="2"></el-input>
              </el-form-item>
              <el-form-item label="支出方式:"  prop="settlementTypeName" v-if="!customFlag">
                <el-select  v-model="addFrom.settlementTypeName"  placeholder="请选择"  >
                  <el-option v-for="item in ZCFSlist"  :label="item.showName" :value="item.showName" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <br>
               <el-form-item label="代发工资税点(%):"  prop="payrollTaxPoint " v-if="!customFlag">
                <el-input maxlength="5" v-model.trim="addFrom.payrollTaxPoint" v-number-input.float="2"></el-input>
              </el-form-item>
            </div>
            <div style="margin-left: 30px;font-size: 17px;font-weight: 600;"  >其他设置</div>
            <div style="margin-top: 20px;" v-if="customFlag">
              <el-form-item label="是否共享客户:" prop="shareFlag" v-if="customFlag">
                <template >
                  <el-radio-group v-model="addFrom.shareFlag"  >
                    <el-radio label="0" >不共享</el-radio>
                    <el-radio label="1">共享</el-radio>
                  </el-radio-group>
                </template>
              </el-form-item>
              <el-form-item label="装车凭证是否必填:" label-width="150px" prop="loadingVoucher" v-if="customFlag">
                <template >
                  <el-radio-group v-model="addFrom.loadingVoucher"  >
                    <el-radio label="0" >否</el-radio>
                    <el-radio label="1">是</el-radio>
                  </el-radio-group>
                </template>
              </el-form-item>
            </div>
            <div  style="margin-top: 20px;"  v-if="!customFlag">
              <el-form-item label="网货承运商:" prop="onlineFlag">
                  <el-radio-group v-model="addFrom.onlineFlag" @change="onlineFlagChange">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
              </el-form-item>
              <el-form-item label="运单上报网货:" prop="onlineFreightFlag" v-if="addFrom.onlineFlag==1" >
                  <el-radio-group v-model="addFrom.onlineFreightFlag">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
              </el-form-item>
              <el-form-item label="服务费计算:" prop="reverseCountFlag" >
                  <el-radio-group v-model="addFrom.reverseCountFlag">
                    <el-radio :label="1">反算</el-radio>
                    <el-radio :label="0">正算</el-radio>
                  </el-radio-group>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 选择地址 -->
    <mapAddressT :addFrom="addFrom" v-if="dizhiMark" @getAddress="getAddress" @destroy="destroy" :customFlag="true"></mapAddressT>
    <!-- 查看营业执照 -->
    <el-dialog :title="lookTitle" :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeLook" :visible.sync="lookDialog" width="500px" center>
      <div style="width: 260px; height: 300px;margin:20px auto;">
        <el-form :inline="true" :model="lookFrom" ref="lookFrom" class="demo-form-inline" size="mini">
          <el-form-item v-if="lookDialog">
            <span v-if="!isHeTong">
              <el-image :src="lookFrom.fileKeyUrl" style="width: 260px; height: 200px;"
                :preview-src-list="[lookFrom.fileKeyUrl]">
              </el-image>
            </span>
            <span v-else>
              <!-- <uploadFiles style="width: 260px;" :fileArr.sync='lookFrom.contractFileList' :disabledFlag="true"></uploadFiles> -->
              <el-upload disabled action="" multiple :file-list="lookFrom.contractFileList"
              :on-preview="handlePictureCardPreview">
              </el-upload>
            </span>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="lookDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 签订合同 -->
    <el-dialog :title="contractsTitle" :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeContractsDialog" :visible.sync="contractsDialog" width="700px" center v-if="contractsDialog">
      <span>
        <el-form :inline="false" :rules="rules" :model="contractsFrom" ref="contractsFrom" class="demo-form-inline" label-width="140px" size="mini">
          <div class="inpBox">
            <el-form-item label="合同编号:" prop="contractNo">
              <el-input placeholder="合同编号" maxlength="50" v-model.trim="contractsFrom.contractNo"
              ></el-input>
            </el-form-item>
            <el-form-item label="有效开始日期:" prop="contractStartDate">
              <el-date-picker
                v-model="contractsFrom.contractStartDate"
                size="mini"
                style="width: 195px"
                placeholder="选择日期"
                type="date"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="有效结束日期:" prop="contractEndDate">
              <el-date-picker
                v-model="contractsFrom.contractEndDate"
                size="mini"
                style="width: 195px"
                placeholder="选择日期"
                type="date"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="合同照片:" v-if="contractsDialog" class="is-required">
              <uploadFiles style="width:300px;" :fileArr.sync='contractFileList' :max='10' @change='imgPreview' @remove='handleRemove' @handlePicPreview = 'handlePicPreview' v-if="contractsDialog"></uploadFiles>
            </el-form-item>
          </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeContractsDialog">取 消</el-button>
        <el-button type="primary" @click="contractsSubmitFn('contractsFrom')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 查看合同 -->
    <el-dialog title="查看合同" :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeReadContract" :visible.sync="readContractVisible" width="60%" center v-if="readContractVisible">
      <div>
        <div class="searchBox">
          <el-form :inline="true" :model="readContractFrom" ref="readContractFrom" class="demo-form-inline" label-width="140px" size="mini">
            <div class="inpBox">
              <el-form-item label="合同编号:" prop="contractNo">
                <el-input placeholder="合同编号" maxlength="50" v-model.trim="readContractFrom.contractNo"
                ></el-input>
              </el-form-item>
              <el-form-item label="生效状态:" prop="contractStates">
                <el-select v-model="readContractFrom.contractStates" placeholder="请选择">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="未生效" value="1"></el-option>
                  <el-option label="已生效" value="2"></el-option>
                  <el-option label="超期预警" value="3"></el-option>
                  <el-option label="已过期" value="4"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="结算客户:" prop="customerName" v-if="customFlag">
                <el-input v-model.trim="readContractFrom.customerName" disabled></el-input>
              </el-form-item>
              <el-form-item label="承运商名称:" prop="customerName" v-if="!customFlag">
                <el-input v-model.trim="readContractFrom.customerName" disabled></el-input>
              </el-form-item>
              <el-form-item label="有效开始日期:" prop="contractStartDates">
                <el-date-picker
                  v-model="readContractFrom.contractStartDates"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="有效结束日期:" prop="contractEndDates">
                <el-date-picker
                  v-model="readContractFrom.contractEndDates"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
              <div class="searchBtnBox" style="margin-bottom:10px;">
                <el-form-item>
                  <el-button type="primary" @click="searchReadContract" size="mini">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="readContractreset('readContractFrom')" size="mini">重置</el-button>
                </el-form-item>
                <el-form-item >
                  <el-button type="primary" @click="delContractFn" size="mini">删除</el-button>
                </el-form-item>
                <el-form-item >
                  <el-button type="primary" @click="exportFn" size="mini" :disabled="isDisable">导出</el-button>
                </el-form-item>
              </div>
            </div>
          </el-form>
        </div>
        <div >
          <el-table :data="readContracttable" ref="readContracttable" v-loading="loading" bordersize="mini" @selection-change='selectGoods'
          @row-click="readContracRowClick" style="width: 100%" max-height="450" center border>
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="editContractFn(scope.row)">修改</el-button>
                <el-button type="text" size="mini" @click="lookContract(scope.row)">合同</el-button>
              </template>
            </el-table-column>
            <el-table-column width="100" label="生效状态">
              <template slot-scope="scope">
                <div class="textColor backColor1" v-show="scope.row.contractStates == '1'">未生效</div>
                <div class="textColor backColor2" v-show="scope.row.contractStates == '2'">已生效</div>
                <div class="textColor backColor3" v-show="scope.row.contractStates == '3'">超期预警</div>
                <div class="textColor backColor4" v-show="scope.row.contractStates == '4'">已过期</div>
              </template>
            </el-table-column>
            <el-table-column prop="contractNo" width="220" label="合同编号"></el-table-column>
            <el-table-column prop="contractStartDate" width="130" :formatter="dateFormat" label="有效开始日期"></el-table-column>
            <el-table-column prop="contractEndDate" width="130" :formatter="dateFormat" label="有效结束日期"></el-table-column>
            <el-table-column prop="createUser" :formatter="emptyFn" label="创建人"></el-table-column>
            <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div>
          <el-pagination background
            @size-change="readContractSizeChange"
            @current-change="readContractCurrentChange"
            :current-page="readContractFrom.pageNo"
            :page-sizes="[50,100,200,1000]"
            :page-size="readContractFrom.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="readContractTotal">
          </el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeReadContract">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 绑定业务人员 -->
    <el-dialog title="绑定业务人员" :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeBindDialog" :visible.sync="bindVisible" width="500px" center v-if="bindVisible">
      <span>
        <el-form :inline="true" :rules="rules" :model="bindFrom" ref="bindFrom" class="demo-form-inline" label-width="160px" size="mini">
          <div class="inpBox">
            <el-form-item label="业务人员:" prop="businessUserCode">
              <el-select v-model="bindFrom.businessUserCode" placeholder="请选择业务人员" @change="bindBusinessChange">
                <el-option v-for="item in currUserList" :label="item.userName" :value="item.userCode" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeBindDialog">取 消</el-button>
        <el-button type="primary" @click="bindSubmitFn('bindFrom')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 绑定人员记录 -->
    <el-dialog title="业务人员" :visible="YWRYMark" :close-on-click-modal="false" width="750px" center @close="closeYWRYDialog">
      <div class="addressBox">
        <div style="margin:20px 0;">结算客户：{{ YWRYCustomer }}</div>
        <el-table :data="getCustomerList" ref="getCustomerList" border size="mini" :header-cell-style="{background:'#F5F5F5',color:'black'}">
          <el-table-column type="index" width="55" label="序号"></el-table-column>
          <el-table-column prop="businessUserName" label="业务人员" align="center" ></el-table-column>
          <el-table-column prop="createUser" label="绑定人" align="center" width="">
          </el-table-column>
          <el-table-column prop="createTime" :formatter="dateTimeFormat" label="绑定时间"></el-table-column>
        </el-table>
        <!-- 分页 -->
        <div style="margin-top: 20px;text-align: right;">
          <el-pagination background
            @size-change="handleYWRYMarkSizeChange"
            @current-change="handleYWRYMarkCurrentChange"
            :current-page="YWRYFrom.pageNo"
            :page-sizes="[50,100,200,1000]"
            :page-size="YWRYFrom.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="YWRYTotal">
          </el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="YWRYMark = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
 </template>
<script>
import { findCustomerInfoList, addCustomerInfo, updateCustomerInfo, getFileShow, deleteFile, deleteCustomerInfo, addCustomerContract, findCustomerContractList, updateCustomerContract, selectCustomerDetail,
  deleteCustomerContract, saveBusinessUser, findCustomerBusinessUserList, getDictionaryDetailList } from '@/api/newTMS'
import { getDepartmentUsers } from '@/api/newCrm'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import uploadImgs from '@/components/uploadImgs.vue'
import mapAddressT from '@/components/common/TMSMap.vue'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import uploadFiles from '@/views/newTMS/publicFiles/uploadFiles.vue'
export default {
  props: {
    customFlag: {
      type: Boolean,
      default: function () {
        return {}
      }
    },
    btnFlg: {
      type: Array,
      default: function () {
        return {}
      }
    }
  },
  components: {
    uploadImgs,
    mapAddressT,
    uploadFiles
  },
  data () {
    return {
      h: 500,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      title: '新建',
      dialogVisible: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        businessType: ''
      },
      total: 0,
      loading: 'false',
      rules: {
        customerName: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        // customerTaxId: [
        //   { required: true, message: '请输入统一社会信用代码', trigger: 'blur' }
        // ],
        periodDays: [
          { required: true, message: '请输入账期', trigger: 'blur' }
        ],
        periodDaysType: [
          { required: true, message: '请选择账期计算开始日', trigger: 'change' }
        ],
        invoiceDays: [
          { required: true, message: '请输入到票期限', trigger: 'blur' }
        ],
        locatedIn: [
          { required: true, message: '请选择企业地址', trigger: 'blur' }
        ],
        contactsUser: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
          { pattern: this.rule.xingming, message: '联系人必须2-20 个汉字' }
        ],
        contactsMobile: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { validator: this.rule.shouJiDianHua, trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          this.rule.mobile
        ],
        onlineFreightFlag: [
          { required: true, message: '请选择是否网货平台', trigger: 'blur' }
        ],
        contractNo: [
          { required: true, message: '请输入合同编号', trigger: 'blur' }
        ],
        contractStartDate: [
          { required: true, message: '请选择有效开始日期', trigger: 'blur' }
        ],
        contractEndDate: [
          { required: true, message: '请选择有效结束日期', trigger: 'blur' }
        ],
        businessUserCode: [
          { required: true, message: '请选择业务人员', trigger: 'change' }
        ],
        taxRate: [
          { required: true, message: '请输入运费税率', trigger: 'blur' }
        ],
        serviceRate: [
          { required: true, message: '请输入服务费率', trigger: 'blur' }
        ],
        payrollTaxPoint: [
          { required: true, message: '请输入代发工资税点', trigger: 'blur' }
        ],
        customerTaxId: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { validator: this.rule.idCardValidity, trigger: 'blur' }
        ],
        loadingVoucher: [
          { required: true, message: '请选择装车凭证是否必填', trigger: 'change' }
        ],
        onlineFlag: [
          { required: true, message: '请选择是否网货承运商', trigger: 'change' }
        ],
        reverseCountFlag: [
          { required: true, message: '请选择是否反算', trigger: 'change' }
        ]

      },
      addFrom: {},
      dizhiMark: false, // 地址
      isDisable: false, // 导出
      isAdd: false,
      row: {},
      imgList: [],
      lookDialog: false,
      lookFrom: {
        contractFileList: []
      },
      delImgID: [],
      contractsTitle: '签订合同',
      contractsDialog: false,
      contractsFrom: {
        contractNo: ''
      },
      contractFileList: [],
      contractAdd: false,
      readContractVisible: false,
      readContracttable: [],
      readContractFrom: {
        pageNo: 1,
        pageSize: 50,
        customerId: ''
      },
      hetongId: '',
      readContractTotal: 0,
      contractDelID: [],
      lookTitle: '',
      isHeTong: false,
      disCustomerTaxId: false,
      bindVisible: false,
      bindFrom: {
        ids: [],
        businessUserCode: '',
        businessUserName: ''
      },
      currUserList: [],
      getCustomerList: [],
      YWRYMark: false,
      YWRYCustomer: '',
      YWRYTd: '',
      YWRYFrom: {
        pageNo: 1,
        pageSize: 50
      },
      YWRYTotal: 0,
      ZCFSlist: []
    }
  },
  created () {
    // console.log(this.customFlag,'customFlag')
    // console.log(this.btnFlg,'this.btnFlg')
    // businessType 业务类型1. 客户，2承运商 ※必传
    if (this.customFlag) {
      this.searchFrom.businessType = '1'
    } else {
      this.searchFrom.businessType = '2'
      getDictionaryDetailList({ dictionaryType: 'down_settlement_type' }).then(res => { this.ZCFSlist = res })
    }
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 166) + 'px'
  },
  methods: {
    // 客户类型修改
    KHLXchage (e) {
      if (e == 1) {
        this.rules.customerName = [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ]
      } else {
        this.rules.customerName = [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { pattern: /^[\u4e00-\u9fff·]{2,5}$/, message: '客户名称必须2-5 个汉字' }
        ]
      }
      // this.$refs.addFrom.validate()
    },
    onlineFlagChange (e) {
      if (e == 1) {
        this.$set(this.addFrom, 'onlineFreightFlag', 1)
        this.$set(this.addFrom, 'reverseCountFlag', 1)
      } else {
        this.$set(this.addFrom, 'onlineFreightFlag', 0)
        this.$set(this.addFrom, 'reverseCountFlag', 0)
      }
    },
    selectCustomerDetail (custerName) {
      selectCustomerDetail({
        tenantCode: localStorage.getItem('tenantCode'),
        custerName: custerName
      }).then(res => {
        console.log(JSON.parse(res), '获取客户')
        let resData = JSON.parse(res)
        if (resData.taxpayerNumber) {
          this.addFrom.customerTaxId = resData.taxpayerNumber
          this.disCustomerTaxId = true
          // 只返回legalPerson法人姓名，无电话
        }
        if (resData.address) {
          this.$set(this.addFrom, 'locatedIn', resData.address)
          // 接口未返回省市县数据，点击选择地址无法赋值
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    // 客户名称失去焦点
    nameBlur () {
      // 调CRM接口，CRM有信息直接填充
      if (this.addFrom.customerType == 1) {
        this.selectCustomerDetail(this.addFrom.customerName)
      }
      // console.log(this.addFrom.customerName,'123')
    },
    // 添加
    addFn () {
      this.addFrom = {}
      if (this.customFlag) {
        this.title = '添加客户'
        this.$set(this.addFrom, 'shareFlag', '0')
        this.$set(this.addFrom, 'customerType', 1)
        this.$set(this.addFrom, 'loadingVoucher', '0')
      } else {
        this.title = '添加承运商'
        this.$set(this.addFrom, 'onlineFlag', 0)
        this.$set(this.addFrom, 'onlineFreightFlag', 0)
        this.$set(this.addFrom, 'reverseCountFlag', 0)
        this.$set(this.addFrom, 'serviceRate', 0)
        this.$set(this.addFrom, 'payrollTaxPoint', 0)
        this.$set(this.addFrom, 'taxRate', 9)
        this.$set(this.addFrom, 'customerType', 1)
        this.$set(this.addFrom, 'settlementTypeName', '现结')
      }
      this.dialogVisible = true
      this.isAdd = true
      this.imgList = []
    },
    // 修改
    editFn (row) {
      this.title = '修改'
      this.getFileShow(row, 'customer', false)
      this.addFrom = { ...row }
      this.$set(this.addFrom, 'locatedIn', row.locatedIn)
      this.$set(this.addFrom, 'periodDaysType', (row.periodDaysType.toString()))
      this.imgList = []
      this.isAdd = false
    },
    handleRemove (data) {
      console.log('data---', data)
      this.contractDelID = []
      if (data.id) {
        this.contractDelID.push(data.id)
      }
    },
    imgPreview (data) {
      console.log('传', data)
      this.contractFileList = data
    },
    handlePicPreview (file) {
      window.open(file.url)
    },
    handlePictureCardPreview (file) {
      window.open(file.url) // 重新打开一个浏览器页进行预览
    },
    saveFn (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.customFlag) {
            this.$set(this.addFrom, 'businessType', '1')
          } else {
            this.$set(this.addFrom, 'businessType', '2')
            let json = this.ZCFSlist.filter(item => item.showName == this.addFrom.settlementTypeName)
            if (json.length > 0) {
              this.addFrom.settlementType = json[0].itemNo
            }
          }
          if (this.isAdd) {
            let imgfile = new FormData()
            // if (this.imgList.length == 0 || this.imgList[0] == null) {
            //   this.$message({
            //     message: '营业执照不能为空',
            //     type: 'error'
            //   })
            //   return
            // }
            if (this.imgList.length > 0) {
              imgfile.set('files', this.imgList[0].raw)
            }
            imgfile.set('params', JSON.stringify(this.addFrom))
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            addCustomerInfo(imgfile).then(res => {
              loading.close()
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            // 修改文件记录删除id，修改接口成功之后调删除文件接口，不修改文件不传files参数
            let imgfile = new FormData()
            // if (this.imgList.length == 0 || this.imgList[0] == null) {
            //   this.$message({
            //     message: '营业执照不能为空',
            //     type: 'error'
            //   })
            //   return
            // }
            if (this.imgList.length > 0) {
              if (!this.imgList[0].id) {
                imgfile.set('files', this.imgList[0].raw)
              }
            }
            imgfile.set('params', JSON.stringify(this.addFrom))
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            updateCustomerInfo(imgfile).then(res => {
              loading.close()
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              this.dialogVisible = false
              if (this.delImgID.length > 0) {
                this.deleteFile(this.delImgID)
              }
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        } else {
          return false
        }
      })
    },
    // 地址
    dizhiFn () {
      this.dizhiMark = true
    },
    getAddress (data) {
      this.dizhiMark = false
      console.log(data, 'data')
      for (let key in data) {
        this.addFrom[key] = data[key]
      }
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {},
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.tableList.toggleRowSelection(row)
    },
    // 点击选中
    readContracRowClick (row, column, event) {
      this.$refs.readContracttable.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      findCustomerInfoList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 删除
    delFn (row) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        deleteCustomerInfo({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 导出
    exportFn () {
      let form = this.readContractFrom
      exportExcel(
        this.global.tmsPlus + '/customerContract/exportList',
        form,
        '合同列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    destroy () {
      this.dizhiMark = false
    },
    // 重置
    resetForm (formName) {
      if (this.customFlag) {
        this.searchFrom = {
          pageNo: 1,
          pageSize: 50,
          businessType: '1'
        }
      } else {
        this.searchFrom = {
          pageNo: 1,
          pageSize: 50,
          businessType: '2'
        }
      }
    },
    closeDialog () {
      this.dialogVisible = false
      this.addFrom = {}
      this.$refs.tableList.clearSelection()
      this.$refs.addFrom.clearValidate()
    },
    // 删除图片
    remove (file) {
      console.log(file, 'file')
      this.delImgID = []
      if (file.id) {
        this.delImgID.push(file.id)
      }
    },
    // 删除文件接口
    deleteFile (idArr) {
      deleteFile({
        ids: idArr
      }).then(res => {
        console.log(res, '删除文件')
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    getFileShow (params, businessType, isLook) {
      // businessId ※必传 对应业务类型主表id
	    // businessType ※必传 业务类型 订单：order；客户承运商：customer；合同：contract
      getFileShow({
        businessId: params.id,
        businessType: businessType
      }).then(res => {
        console.log(res, '营业执照')
        if (businessType == 'customer') { // 客户承运商
          // 查看文件
          if (isLook) {
            if (res.length != 0) {
              this.lookFrom = res[0]
              this.lookDialog = true
            } else {
              this.$message({
                message: '暂无文件照片',
                type: 'error'
              })
            }
          } else { // 修改
            if (res.length != 0) {
              this.$set(this.imgList, 0, { status: 'ready', url: res[0].fileKeyUrl, isEdit: true, id: res[0].fileId })
            }
            this.dialogVisible = true
          }
        } else {
          if (isLook) {
            if (res.length != 0) {
              res.forEach((item, index) => {
                console.log(item)
                let name = item.url.substring(item.url.lastIndexOf('/') + 1)
                this.$set(this.lookFrom.contractFileList, index, { status: 'ready', name: name, url: item.fileKeyUrl, id: item.fileId })
              })
              this.lookDialog = true
            } else {
              this.$message({
                message: '暂无文件照片',
                type: 'error'
              })
            }
          } else {
            if (res.length != 0) {
              res.forEach((item, index) => {
                let name = item.url.substring(item.url.lastIndexOf('/') + 1)
                this.$set(this.contractFileList, index, { status: 'ready', name: name, url: item.fileKeyUrl, id: item.fileId })
              })
            }
          }
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    lookPhotos (row) {
      this.lookTitle = '查看营业执照'
      this.isHeTong = false
      this.getFileShow(row, 'customer', true)
    },
    lookContract (row) {
      this.lookTitle = '查看合同'
      this.isHeTong = true
      this.lookFrom.contractFileList = []
      this.getFileShow(row, 'contract', true)
    },
    closeLook () {
      this.lookDialog = false
    },
    contractClick (row) {
      this.contractsDialog = true
      this.contractsFrom = {}
      this.contractFileList = []
      this.$set(this.contractsFrom, 'customerId', row.id)
      this.contractAdd = true
    },
    closeContractsDialog () {
      this.contractsDialog = false
    },
    contractsSubmitFn (formName) {
      console.log(this.contractFileList, 'this.contractFileList')
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log(Date.parse(this.contractsFrom.contractEndDate),'111')
          if (this.contractsFrom.contractEndDate < this.contractsFrom.contractStartDate) {
            this.$alert('有效结束日期必须大于有效开始日期', '系统提示')
            return
          }
          let imgfile = new FormData()
          if (this.contractFileList.length > 0) {
            for (var i = 0; i < this.contractFileList.length; i++) {
              let a = i
              if (!this.contractFileList[i].id) {
                imgfile.append('files', this.contractFileList[i].raw)
              } else {}
              if (a == this.contractFileList.length - 1) {
                imgfile.set('params', JSON.stringify(this.contractsFrom))
                if (this.contractAdd) {
                  this.addCustomerContract(imgfile)
                } else {
                  // 修改文件记录删除id，修改接口成功之后调删除文件接口，不修改文件不传files参数
                  this.updateCustomerContract(imgfile)
                }
              }
            }
          } else {
            this.$alert('请选择文件图', '系统提示')
          }
        } else {
          return false
        }
      })
    },
    // 新增合同
    addCustomerContract (imgfile) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      addCustomerContract(imgfile).then(res => {
        loading.close()
        this.$message({
          message: '添加成功',
          type: 'success'
        })
        this.contractsDialog = false
        this.getList(this.searchFrom)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 修改合同
    updateCustomerContract (imgfile) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      updateCustomerContract(imgfile).then(res => {
        loading.close()
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.contractsDialog = false
        console.log(this.contractDelID, 'this.contractDelID')
        if (this.contractDelID.length > 0) {
          this.deleteFile(this.contractDelID)
        }
        this.findCustomerContractList()
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 点击合同数
    contractNumberFn (row) {
      if (row.contractNumber == 0) {
        this.$alert('暂无合同', '系统提示')
      } else {
        this.hetongId = ''
        this.readContractVisible = true
        this.readContractFrom.customerName = row.customerName
        this.readContractFrom.customerId = row.id
        this.hetongId = row.id
        this.findCustomerContractList()
      }
    },
    // 查看合同列表
    findCustomerContractList () {
      this.loading = true
      findCustomerContractList(this.readContractFrom).then(res => {
        this.loading = false
        this.readContracttable = res.list
        this.readContractTotal = res.total
      })
    },
    // 查看合同关闭
    closeReadContract () {
      this.readContractVisible = false
      this.readContractFrom = {
        pageNo: 1,
        pageSize: 50,
        customerId: this.hetongId
      }
    },
    // 合同列表查询
    searchReadContract () {
      this.findCustomerContractList()
    },
    // 合同列表重置
    readContractreset () {
      this.readContractFrom = {
        pageNo: 1,
        pageSize: 50,
        customerId: this.hetongId
      }
      this.findCustomerContractList()
    },
    // 合同列表分页
    readContractSizeChange (val) {
      this.readContractFrom.pageSize = val
      this.findCustomerContractList()
    },
    readContractCurrentChange (val) {
      this.readContractFrom.pageNo = val
      this.findCustomerContractList()
    },
    // 修改合同
    editContractFn (row) {
      this.contractsDialog = true
      this.contractsTitle = '修改合同'
      this.getFileShow(row, 'contract', false)
      this.$set(this.contractsFrom, 'id', row.id)
      this.$set(this.contractsFrom, 'contractNo', row.contractNo)
      this.$set(this.contractsFrom, 'contractStartDate', this.dateFormatDate(row.contractStartDate))
      this.$set(this.contractsFrom, 'contractEndDate', this.dateFormatDate(row.contractEndDate))
      this.contractFileList = []
      this.contractDelID = []
      this.contractAdd = false
    },
    // 删除合同
    delContractFn () {
      const selectData = this.$refs.readContracttable.selection
      console.log(selectData, 'selectData')
      if (selectData.length > 0) {
        this.$confirm('是否执行删除操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          var ids = []
          selectData.forEach(item => {
            ids.push(item.id)
          })
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          deleteCustomerContract({ ids: ids }).then(res => {
            loading.close()
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.findCustomerContractList()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }).catch(() => {

        })
      } else {
        this.$alert('请至少选择一条数据进行操作', '系统提示')
      }
    },
    // 绑定业务人员
    bindingFn () {
      const selectData = this.$refs.tableList.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        this.bindFrom.ids = []
        selectData.forEach(item => {
          this.bindFrom.ids.push(item.id)
        })
        this.bindVisible = true
        this.getDepartment()
      }
    },
    bindBusinessChange (e) {
      console.log(e, 'e')
      this.currUserList.forEach(item => {
        if (e == item.userCode) {
          this.bindFrom.businessUserName = item.userName
        }
      })
    },
    closeBindDialog () {
      this.bindVisible = false
    },
    // 获取业务人员下拉框
    getDepartment () {
      getDepartmentUsers({
        subOrgCode: localStorage.getItem('orgSubCode'),
        bussinessUserFlag: 1
      }).then(res => { this.currUserList = res })
    },
    bindSubmitFn (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.bindFrom.ids = this.bindFrom.ids.toString()
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          saveBusinessUser(this.bindFrom).then(res => {
            loading.close()
            this.$message({
              message: '绑定成功',
              type: 'success'
            })
            this.bindVisible = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          return false
        }
      })
    },
    busUserFn (row) {
      this.YWRYMark = true
      this.YWRYCustomer = row.customerName
      this.YWRYTd = row.id
      this.findCustomerBusinessUserList()
    },
    findCustomerBusinessUserList () {
      findCustomerBusinessUserList({
        id: this.YWRYTd,
        pageNo: this.YWRYFrom.pageNo,
        pageSize: this.YWRYFrom.pageSize
      }).then(res => {
        this.getCustomerList = res.list
        this.YWRYTotal = res.total
      })
    },
    closeYWRYDialog () {
      this.YWRYMark = false
    },
    handleYWRYMarkSizeChange (val) {
      this.YWRYFrom.pageSize = val
      this.findCustomerBusinessUserList()
    },
    handleYWRYMarkCurrentChange (val) {
      this.YWRYFrom.pageNo = val
      this.findCustomerBusinessUserList()
    },
    // 时间格式化
    dateFormatDate: function (cellValue) {
      var t = new Date(cellValue)
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var str = ''
      if (cellValue == null) {
        str = '-'
      } else {
        str = t.getFullYear() + '-' + month + '-' + date
      }
      return str
    }
  },
  destroyed () {
    if (this.msg) {
      this.msg.close()
    }
  }
}
</script>
 <style scoped lang='less'>
  .dizhi{
    position: relative;
    .el-icon-location{
     position: absolute;
     right: -30px;
     top: 0;
     font-size: 25px;
     color: #0c46a2;
   }
   /deep/.el-input__inner{
     width: 440px!important;
   }
  }
  /deep/.el-input.is-disabled .el-input__inner {
    color: #606266;
    cursor: not-allowed;
  }
 .searchBtnBox {
   margin-left: 10px;
 }
 .searchBox .el-date-editor{
    width: 230px!important;
 }
 .imgBox{
   display: flex;
   .item{
     display: flex;
      width: 50%;
      justify-content: space-around;
   }
 }
 /deep/.inpBox .el-input__inner{
   width:190px;
 }
 .detail /deep/.el-form-item__content{
   width: 150px;
 }
 .textColor{
    color: #fff;
    border-radius: 3px;
 }
 .backColor1{
    background-color:#a4adb3;
 }
 .backColor2{
    background-color:#81b337;
 }
 .backColor3{
    background-color:#e99d42;
 }
 .backColor4{
    background-color:#d51212;
 }
 /deep/.el-form {
  width: 100%;
 }
</style>
